import React, { useEffect, useState } from "react";
import PieChart from "./3DpieChart";
import BarChart from "./barChart";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DatePicker, useScreenSize } from "../../components";
// import StationPerformance from "./stationPerformance";
import GeneralPerformance from "./general";
import exporting from "highcharts/modules/exporting";
// import exportData from "highcharts/modules/export-data";
import accessibility from "highcharts/modules/accessibility";
import LocationMetrics from "./DemographicReports/location";
import AgeRange from "./DemographicReports/AgeRange";
import Gender from "./DemographicReports/Gender";
import BrandMetrics from "./BrandMetrics";
import SKUMetrics from "./SkuMetrics";
import { addDays, set } from "date-fns";
import MultiSelect from "../../components/MultiSelect";
import { useSearchParams } from "react-router-dom";
import ChannelsPerformance from "./channels-performance";

// Initialize exporting and accessibility modules
exporting(Highcharts);
// exportData(Highcharts);
accessibility(Highcharts);

const categories = [
  "General Performance",
  "Daily Entries Breakdown",
  "Rewards Breakdown",
  "Regional Distribution",
  "Age Group Distribution",
  "Gender Distribution",
  "Brands Performance",
  "SKU Performance",
  "Channels Performance",
];

const Reports = () => {
  const dimensions = useScreenSize();
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("query");
  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
      endDate: new Date().setHours(23, 59, 59, 0),
      key: "selection",
    },
  ]);
  const [selectedCategories, setSelectedCategories] = useState(categories);

  useEffect(() => {
    const selectedCategoriesInQuery = query?.split(",");
    if (selectedCategoriesInQuery?.[0].length > 0) {
      setSelectedCategories(selectedCategoriesInQuery);
    } else {
      setSelectedCategories(categories);
    }
  }, []);

  const [open, setOpen] = useState(false);

  return (
    <div className="h-full px-4 md:px-8 w-full">
      <h1 className=" text-[24px] leading-9 font-[600] mb-4">Reports</h1>

      <div className="flex flex-col gap-2 md:items-center md:flex-row ">
        <div className="flex items-center gap-2">
          <p>Filter</p>
          <span>
            <svg
              width="16"
              height="18"
              viewBox="0 0 20 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.3766 21.4262C12.1636 21.4252 11.9548 21.3668 11.7722 21.2571L7.88258 18.9237C7.44502 18.6597 7.08281 18.2874 6.83087 17.8428C6.57892 17.3981 6.44571 16.8961 6.44408 16.3851V11.1059C6.44515 10.7333 6.32926 10.3697 6.11275 10.0664L0.681915 2.43406C0.555102 2.25786 0.479427 2.05006 0.463241 1.83358C0.447055 1.6171 0.490987 1.40035 0.590189 1.20726C0.689391 1.01417 0.840007 0.852229 1.02542 0.739318C1.21083 0.626407 1.42383 0.56691 1.64091 0.567393H18.3592C18.5765 0.566488 18.7898 0.625725 18.9754 0.738546C19.1611 0.851367 19.3119 1.01337 19.4112 1.20662C19.5105 1.39987 19.5544 1.61682 19.538 1.83346C19.5215 2.0501 19.4455 2.25797 19.3182 2.43406L13.8874 10.0664C13.6706 10.3696 13.5543 10.7331 13.5549 11.1059V20.2456C13.5546 20.5582 13.4304 20.858 13.2096 21.0793C12.9887 21.3005 12.6892 21.4253 12.3766 21.4262ZM1.64091 1.73989L7.06241 9.38973C7.42064 9.89012 7.61246 10.4905 7.61075 11.1059V16.3839C7.61152 16.6935 7.69213 16.9977 7.84479 17.267C7.99746 17.5364 8.21701 17.7618 8.48225 17.9216L12.3719 20.2549L12.3882 11.1047C12.3869 10.4892 12.5792 9.88885 12.9377 9.38856L18.3674 1.75623L1.64091 1.73989Z"
                fill="black"
              />
            </svg>
          </span>
          <MultiSelect
            options={categories}
            selectedOptions={selectedCategories}
            setSelectedOptions={(options) => {
              setSelectedCategories(options);
            }}
            openHandler={open}
            setOpenHandler={setOpen}
            title="Select Category"
            containerClass={"md:w-[250.67px] w-full"}
            footerComponent={(tempTags) => (
              <div className="flex border-t py-2 px-4 justify-between items-center gap-4">
                <button
                  onClick={() => {
                    setOpen(false);
                  }}
                  className="text-[#454545] flex items-center gap-1 text-sm"
                >
                  <span>
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
                        fill="black"
                      />
                    </svg>
                  </span>
                  <span>Cancel</span>
                </button>
                <button
                  onClick={() => {
                    setSelectedCategories(tempTags);
                    if (tempTags.length === 0) {
                      setSearchParams({ query: "" }, { replace: true });
                      setOpen(false);
                      return;
                    }
                    setSearchParams(
                      { query: tempTags.join(",") },
                      { replace: true }
                    );
                    setOpen(false);
                  }}
                  className="bg-[#3989DD] hover:opacity-90 text-white rounded px-4 py-1"
                >
                  Apply
                </button>
              </div>
            )}
          />
        </div>
        <div className="border rounded">
          <DatePicker state={state} setState={setState} />
        </div>
      </div>

      <div className="mt-8 flex flex-col">
        {selectedCategories.includes("General Performance") && (
          <GeneralPerformance state={state} />
        )}

        {selectedCategories.includes("Daily Entries Breakdown") && (
          <BarChart
            state={state}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
          />
        )}
        {selectedCategories.includes("Rewards Breakdown") && (
          <PieChart
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("Regional Distribution") && (
          <LocationMetrics
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("Age Group Distribution") && (
          <AgeRange
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("Gender Distribution") && (
          <Gender
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("Brands Performance") && (
          <BrandMetrics
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("SKU Performance") && (
          <SKUMetrics
            dimensions={dimensions}
            HighchartsReact={HighchartsReact}
            Highcharts={Highcharts}
            state={state}
          />
        )}
        {selectedCategories.includes("Channels Performance") && (
          <ChannelsPerformance state={state} />
        )}
      </div>
    </div>
  );
};

export default Reports;
